import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as UndoStack from '../reducers/UndoStack'
import FolderTitle from './FolderTitle'

import * as actions from '../actions'

const DeleteButton = (props) => (
  <button
    type="button"
    onClick={props.onClick}
    className="button folderTitleButton folderTitleDeleteButton"
  >
    {props.isRoot ? 'Delete Board' : 'Delete Folder'}
  </button>
)

const ShareButton = (props) => (
  <button
    type="button"
    onClick={props.onClick}
    className="button folderTitleButton folderTitleShareButton"
  >
    Share Board
  </button>
)

const UndoButton = (props) => (
  <button
    type="button"
    onClick={props.onClick}
    className={`button folderTitleButton folderTitleUndoButton${
      props.disabled ? ' disabled' : ''
    }`}
  >
    Undo
  </button>
)

const RedoButton = (props) => (
  <button
    type="button"
    onClick={props.onClick}
    className={`button folderTitleButton folderTitleRedoButton${
      props.disabled ? ' disabled' : ''
    }`}
  >
    Redo
  </button>
)

class FolderTitleBar extends Component {
  onClickShare = () => {
    this.props.onClickShare()
  }

  onClickDelete = () => {
    if (this.props.isRoot) {
      if (
        !window.confirm(
          'Are you sure you want to delete this board and its content?',
        )
      ) {
        return
      }
      this.props.deleteContent(this.props.contentId)
    } else {
      if (
        !window.confirm(
          'Are you sure you want to delete this folder and its content?',
        )
      ) {
        return
      }
      this.props.removeNode(this.props.folder.id)
    }
  }

  onClickUndo = () => {
    this.props.undoContentChange()
  }

  onClickRedo = () => {
    this.props.redoContentChange()
  }

  render() {
    const { folder, isViewOnly, isRoot, canUndo, canRedo } = this.props
    return (
      <div className="folderTitleBar">
        <div className="folderTitleBarContainer">
          <div className="folderTitleBarTitleContainer">
            <FolderTitle
              isViewOnly={isViewOnly}
              folder={folder}
              isRoot={isRoot}
            />
          </div>
          {!isViewOnly && (
            <DeleteButton isRoot={isRoot} onClick={this.onClickDelete} />
          )}
          {!isViewOnly && isRoot && <ShareButton onClick={this.onClickShare} />}
          {!isViewOnly && canRedo && <RedoButton onClick={this.onClickRedo} />}
          {!isViewOnly && canUndo && <UndoButton onClick={this.onClickUndo} />}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const { undoStack } = state.app
  const { contentId } = ownProps
  return {
    canUndo: UndoStack.canUndo(undoStack, contentId),
    canRedo: UndoStack.canRedo(undoStack, contentId),
  }
}

FolderTitleBar.propTypes = {
  folder: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
  }),
  isRoot: PropTypes.bool,
  isReceived: PropTypes.bool,
  canUndo: PropTypes.bool,
  canRedo: PropTypes.bool,
}

const ConnectedFolderTitleBar = connect(
  mapStateToProps,
  actions,
)(FolderTitleBar)
export default ConnectedFolderTitleBar
